<template>
  <div class="container">
    <h2>
      {{ page.Title }}
    </h2>

    <div v-if="page.Content" v-html="page.Content"></div>
    <div class="row">
      <div class="col-md-6">
        <!-- first_name -->
        <doInput
          v-model="page.Questions[0].Value"
          :value="page.Questions[0].Value"
          :id="page.Questions[0].QID"
          :config="page.Questions[0].Config"
        />
      </div>
      <div class="col-md-6">
        <!-- last_name -->
        <doInput
          v-model="page.Questions[1].Value"
          :value="page.Questions[1].Value"
          :id="page.Questions[1].QID"
          :config="page.Questions[1].Config"
        />
      </div>
    </div>
    <!-- cpr_number -->
    <div class="row">
      <div class="col-md-6">
        <!-- hasCPR -->
        <DoCheckbox
          v-model="page.Questions[2].Value"
          :value="page.Questions[2].Value"
          :id="page.Questions[2].QID"
          :config="page.Questions[2].Config"
          :options="page.Questions[2].Options"
          @doChange="resetCpr"
        />
      </div>
    </div>
    <!-- cpr_number -->
    <div class="row" v-if="hasCPR" key="hideExtraAddress">
      <div class="col-lg-6" style="margin-top: -25px">
        <doCpr
          v-model="page.Questions[3].Value"
          :value="page.Questions[3].Value"
          :id="page.Questions[3].QID"
          :config="page.Questions[3].Config"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 col-6 hide">
        <!-- country_code -->
        <doCountry
          autocomplete="off"
          v-model="page.Questions[9].Value"
          :value="page.Questions[9].Value"
          :id="page.Questions[9].QID"
          :config="page.Questions[9].Config"
          @getNewData="setCountry"
        />
      </div>
      <div class="col-md-6">
        <!-- country -->
        <doSelect
          v-model="page.Questions[12].Value"
          :value="page.Questions[12].Value"
          :id="page.Questions[12].QID"
          :config="page.Questions[12].Config"
          :options="countryOptions"
          @input="setCountryCode"
        />
      </div>
    </div>
    <AppFlowTransition>
      <div
        class="px-4 pb-4 pt-2 boxed row"
        v-if="showState"
        key="showExtraAddress"
      >
        <div class="col-md-4" v-if="!hasCPR">
          <!-- birthday -->
          <doDate
            v-model="page.Questions[16].Value"
            :value="page.Questions[16].Value"
            :id="page.Questions[16].QID"
            :config="page.Questions[16].Config"
          />
        </div>
        <div class="col-md-4" v-if="!hasCPR">
          <!-- gender -->
          <doSelect
            v-model="page.Questions[17].Value"
            :value="page.Questions[17].Value"
            :id="page.Questions[17].QID"
            :config="page.Questions[17].Config"
            :options="page.Questions[17].Options"
          />
        </div>
        <div class="col-md-8">
          <!-- att_address -->
          <doInput
            v-model="page.Questions[8].Value"
            :value="page.Questions[8].Value"
            :id="page.Questions[8].QID"
            :config="page.Questions[8].Config"
          />
        </div>
        <div class="col-lg-12" style="padding-left: 0">
          <div class="col-lg-5 col-sm-3 col-4">
            <!-- door or appartment -->
            <doInput
              v-model="page.Questions[7].Value"
              :value="page.Questions[7].Value"
              :id="page.Questions[7].QID"
              :config="page.Questions[7].Config"
            />
          </div>
        </div>
        <div class="col-lg-1 col-sm-3 col-4">
          <!-- street_number -->
          <doInput
            v-model="page.Questions[5].Value"
            :value="page.Questions[5].Value"
            :id="page.Questions[5].QID"
            :config="page.Questions[5].Config"
          />
        </div>
        <div class="col-lg-1 col-sm-3 col-4">
          <!-- floor -->
          <doInput
            v-model="page.Questions[6].Value"
            :value="page.Questions[6].Value"
            :id="page.Questions[6].QID"
            :config="page.Questions[6].Config"
          />
        </div>
        <div class="col-lg-5 col-sm-9">
          <!-- street -->
          <doInput
            v-model="page.Questions[4].Value"
            :value="page.Questions[4].Value"
            :id="page.Questions[4].QID"
            :config="page.Questions[4].Config"
          />
        </div>
        <div class="clearfix"></div>
        <div class="col-md-12" style="padding-left: 0">
          <div class="col-md-6">
            <!-- state -->
            <doInput
              v-model="page.Questions[19].Value"
              :value="page.Questions[19].Value"
              :id="page.Questions[19].QID"
              :config="page.Questions[19].Config"
            />
          </div>
        </div>

        <div class="col-md-3 col-6" v-if="hasDKAddress">
          <!-- Zip -->
          <DoZipCode
            v-model="page.Questions[10].Value"
            :value="page.Questions[10].Value"
            :id="page.Questions[10].QID"
            :config="page.Questions[10].Config"
            :options="page.Questions[10].Options"
            @input="setCity()"
          />
        </div>

        <div class="col-md-6" v-if="hasDKAddress">
          <!-- City -->
          <DoCity
            v-model="page.Questions[11].Value"
            :value="page.Questions[11].Value"
            :id="page.Questions[11].QID"
            :config="page.Questions[11].Config"
            :options="page.Questions[11].Options"
            @input="setZip()"
          />
        </div>
        <div class="col-md-3 col-6" v-if="!hasDKAddress">
          <!-- Zip -->
          <DoInput
            v-model="page.Questions[21].Value"
            :value="page.Questions[21].Value"
            :id="page.Questions[21].QID"
            :config="page.Questions[12].Config"
          />
        </div>

        <div class="col-md-6" v-if="!hasDKAddress">
          <!-- City -->
          <DoInput
            v-model="page.Questions[22].Value"
            :value="page.Questions[22].Value"
            :id="page.Questions[22].QID"
            :config="page.Questions[22].Config"
          />
        </div>
      </div>
    </AppFlowTransition>
    <AppFlowTransition>
      <div
        class="px-4 pb-4 pt-2 boxed row"
        v-if="(!hasCPR || !hasDKAddress) && !showState"
        key="showExtraAddress"
      >
        <div class="col-md-4" v-if="!hasCPR">
          <!-- birthday -->
          <doDate
            v-model="page.Questions[16].Value"
            :value="page.Questions[16].Value"
            :id="page.Questions[16].QID"
            :config="page.Questions[16].Config"
          />
        </div>
        <div class="col-md-4" v-if="!hasCPR">
          <!-- gender -->
          <doSelect
            v-model="page.Questions[17].Value"
            :value="page.Questions[17].Value"
            :id="page.Questions[17].QID"
            :config="page.Questions[17].Config"
            :options="page.Questions[17].Options"
          />
        </div>
        <div class="col-md-8">
          <!-- att_address -->
          <doInput
            v-model="page.Questions[8].Value"
            :value="page.Questions[8].Value"
            :id="page.Questions[8].QID"
            :config="page.Questions[8].Config"
          />
        </div>
        <div class="clearfix"></div>
        <div class="col-lg-12" style="padding-left: 0" v-if="isGermany">
          <div class="col-lg-4 col-sm-6">
            <!-- place -->
            <doInput
              v-model="page.Questions[18].Value"
              :value="page.Questions[18].Value"
              :id="page.Questions[18].QID"
              :config="page.Questions[18].Config"
            />
          </div>
        </div>
        <div class="col-lg-5 col-sm-9">
          <!-- street -->
          <doInput
            v-model="page.Questions[4].Value"
            :value="page.Questions[4].Value"
            :id="page.Questions[4].QID"
            :config="page.Questions[4].Config"
          />
        </div>
        <div class="col-lg-1 col-sm-3 col-4">
          <!-- street_number -->
          <doInput
            v-model="page.Questions[5].Value"
            :value="page.Questions[5].Value"
            :id="page.Questions[5].QID"
            :config="page.Questions[5].Config"
          />
        </div>
        <div class="col-lg-1 col-sm-3 col-4">
          <!-- floor -->
          <doInput
            v-model="page.Questions[6].Value"
            :value="page.Questions[6].Value"
            :id="page.Questions[6].QID"
            :config="page.Questions[6].Config"
          />
        </div>
        <div class="col-lg-1 col-sm-3 col-4">
          <!-- door -->
          <doInput
            v-model="page.Questions[7].Value"
            :value="page.Questions[7].Value"
            :id="page.Questions[7].QID"
            :config="page.Questions[7].Config"
          />
        </div>
        <div class="col-lg-4 col-sm-6"></div>
        <div class="col-lg-12" style="padding-left: 0" v-if="!isGermany">
          <div class="col-lg-4 col-sm-6">
            <!-- place -->
            <doInput
              v-model="page.Questions[18].Value"
              :value="page.Questions[18].Value"
              :id="page.Questions[18].QID"
              :config="page.Questions[18].Config"
            />
          </div>
        </div>
        <div class="col-md-3 col-6" v-if="hasDKAddress">
          <!-- Zip -->
          <DoZipCode
            v-model="page.Questions[10].Value"
            :value="page.Questions[10].Value"
            :id="page.Questions[10].QID"
            :config="page.Questions[10].Config"
            :options="page.Questions[10].Options"
            @input="setCity()"
          />
        </div>

        <div class="col-md-6" v-if="hasDKAddress">
          <!-- City -->
          <DoCity
            v-model="page.Questions[11].Value"
            :value="page.Questions[11].Value"
            :id="page.Questions[11].QID"
            :config="page.Questions[11].Config"
            :options="page.Questions[11].Options"
            @input="setZip()"
          />
        </div>
        <div class="col-md-3 col-6" v-if="!hasDKAddress">
          <!-- Zip -->
          <DoInput
            v-model="page.Questions[21].Value"
            :value="page.Questions[21].Value"
            :id="page.Questions[21].QID"
            :config="page.Questions[21].Config"
          />
        </div>

        <div class="col-md-6" v-if="!hasDKAddress">
          <!-- City -->
          <DoInput
            v-model="page.Questions[22].Value"
            :value="page.Questions[22].Value"
            :id="page.Questions[22].QID"
            :config="page.Questions[22].Config"
          />
        </div>
      </div>
    </AppFlowTransition>
    <div class="row">
      <div class="col-md-6">
        <!-- e_mail -->
        <doMail
          autocomplete="off"
          v-model="page.Questions[13].Value"
          :value="page.Questions[13].Value"
          :id="page.Questions[13].QID"
          :config="page.Questions[13].Config"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <doPhone
          v-model="page.Questions[14].Value"
          :value="page.Questions[14].Value"
          :id="page.Questions[14].QID"
          :config="page.Questions[14].Config"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <!-- enrollment_date -->
        <doEnrollmentDate
          v-model="page.Questions[15].Value"
          :value="page.Questions[15].Value"
          :id="page.Questions[15].QID"
          :config="page.Questions[15].Config"
        />
      </div>
    </div>
    <div class="row" v-if="this.$store.state.employment != 5">
      <div class="col-md-6">
        <!-- enrollment_date -->
        {{ page.Questions[20].AdditionalInfo }}
      </div>
    </div>
  </div>
</template>
<script>
  import axios from 'axios';
  import AppFlowTransition from '@/components/base/AppFlowTransition';
  export default {
    inject: {
      $validator: '$validator',
    },
    components: {
      AppFlowTransition,
    },
    props: {
      page: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        countryOptions: [],
        countryList: [],
      };
    },
    created() {
      axios
        .get(this.$store.state.pageData.EndpointCountries)
        .then((response) => {
          this.countryList = response.data;
          this.countryOptions = [
            { Value: 0, Title: 'Vælg' },
            ...response.data.map((item) => {
              return {
                Value: item.name,
                Title: item.name,
              };
            }),
          ];
        });
    },
    mounted() {
      this.page.Questions[9].Value = 'DK';
    },
    computed: {
      showState() {
        return (
          this.page.Questions[9].Value === 'us' ||
          this.page.Questions[9].Value === 'US'
        );
      },
      isGermany() {
        return (
          this.page.Questions[9].Value === 'de' ||
          this.page.Questions[9].Value === 'DE'
        );
      },
      hasCPR() {
        return !this.page.Questions[2].Value;
      },
      hasDKAddress() {
        return this.page.Questions[12].Value === 'Danmark';
      },
      getCountry() {
        return this.page.Questions[9].Value;
      },
    },
    methods: {
      setCountry(country) {
        if (country) {
          this.page.Questions[12].Value = country;
        } else {
          this.page.Questions[12].Value = '';
        }
      },
      setCountryCode(country) {
        if (country) {
          this.page.Questions[9].Value = this.countryList
            .filter(
              (item) => item.name.toUpperCase() === country.toUpperCase()
            )[0]
            .code.toUpperCase();
        } else {
          this.page.Questions[9].Value = '';
        }

        setTimeout(() => {
          this.$validator.validateAll();
        }, 100);
      },
      resetCpr(val) {
        this.$store.state.hasNoCPR = this.page.Questions[2].Value;
        if (val) {
          this.page.Questions[12].Config.readonly = true; // Country
          this.page.Questions[3].Value = '';
        } else {
          this.page.Questions[12].Config.readonly = false; // Country
          this.page.Questions[4].Value = '';
          this.page.Questions[5].Value = '';
          this.page.Questions[6].Value = '';
          this.page.Questions[7].Value = '';
          this.page.Questions[8].Value = '';
          this.page.Questions[10].Value = '';
          this.page.Questions[11].Value = '';
          this.page.Questions[18].Value = '';
          this.page.Questions[19].Value = '';
        }
        // clear session and fetch new data, so insurance step can be shown/hidden
        sessionStorage.clear();
        this.$store.dispatch('doNewData', Number(this.$store.state.employment));
      },
      setZip() {
        if (
          typeof this.page.Questions[11].Value != 'string' &&
          Object.keys(this.page.Questions[11].Value).length &&
          typeof this.page.Questions[11].Value.zip != 'undefined'
        ) {
          this.page.Questions[10].Value =
            this.page.Questions[11].Value.zip.name;
        }
      },
      setCity() {
        if (
          typeof this.page.Questions[10].Value != 'string' &&
          Object.keys(this.page.Questions[10].Value).length &&
          typeof this.page.Questions[10].Value.city != 'undefined'
        ) {
          this.page.Questions[11].Value =
            this.page.Questions[10].Value.city.name;
        }
      },
    },
  };
</script>
<style lang="scss" scoped>
  .mrow {
    width: calc(50% - 24px);
    margin-left: 12px;
    @include media-breakpoint-down(sm) {
      width: auto;
    }
  }
  .lwmobile {
    width: calc(100% - 74px);
  }
  .cwmobile {
    width: 70px;
    margin-right: 24px;
  }
</style>
